import { HTMLAttributes } from "react";

export default function Bulma(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2 0L37.2 15L28.2 24L40.2 35.9625L22.275 48L7.27502 33.0375L10.1625 12.0375L22.2 0Z"
        fill="#00D1B2"
      />
    </svg>
  )
}
